module.exports = __webpack_public_path__ + "static/EWY_Shar-4431266309ed90d368998172c2a60fce.mp4";